import z from 'zod/v4';

import { columns } from './columns';

export * from './base';
export * from './relaxed';
export * from './strict';

export const alphaQuotePriceSchema = z.object(columns);

export type AlphaQuotePrice = z.output<typeof alphaQuotePriceSchema>;
